import { GlobalPointsStats } from "@decibeltrade/sdk";
import { type FetchQueryOptions, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "../dex-sdk";

export function globalPointsStatsQueryKey() {
  return ["globalPointsStats"] as const;
}

export function globalPointsStatsQuery() {
  return {
    queryKey: globalPointsStatsQueryKey(),
    queryFn: async () => readDexSdk.globalPointsStats.get(),
    staleTime: 5 * 60 * 1000, // 5 minutes — data refreshes daily via MV
  } satisfies FetchQueryOptions<GlobalPointsStats>;
}

export function useGlobalPointsStatsQuery() {
  return useQuery(globalPointsStatsQuery());
}
